import { types, flow } from "mobx-state-tree";
import { saveAs } from "file-saver";

import { URL_API } from "./globals";
import { Client, Team } from "./common";

const ItemSelect = types.model("ItemSelect", {
  uuid: types.string,
});

const RepostSilpo = types
  .model("RepostSilpo", {
    date1Order: types.optional(types.string, ""),
    date2Order: types.optional(types.string, ""),
    date1Creation: types.optional(types.string, ""),
    date2Creation: types.optional(types.string, ""),
    client: types.optional(types.maybeNull(types.reference(Client)), null),
  })
  .actions((self) => ({
    setClient(client) {
      self.client = client;
    },
    delClient() {
      self.client = null;
    },
    setExcel: flow(function* () {
      const response = yield fetch(`${URL_API}/api/getexcel`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            date1Order: self.date1Order,
            date2Order: self.date2Order,
            date1Creation: self.date1Creation,
            date2Creation: self.date2Creation,
            client: self.client ? self.client.uuid : null,
          },
        }),
      });
      const json = yield response.json();
      if (json.data.contents) {
        const base64 = json.data.contents;
        const file = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64}`;
        saveAs(file, "report.xlsx");
      }
    }),
    setDate1Order: (date1Order) => (self.date1Order = date1Order),
    setDate2Order: (date2Order) => (self.date2Order = date2Order),
    setDate1Creation: (date1Creation) => (self.date1Creation = date1Creation),
    setDate2Creation: (date2Creation) => (self.date2Creation = date2Creation),
  }));

export default RepostSilpo;
